import type { FaireProductEntity } from "../../entity_types/product";

export const p_wdybyc6xms: FaireProductEntity = {
  token: "p_wdybyc6xms",
  type: "product",
  name: "Puka Shell Lariat Necklace",
  brandToken: "b_d5ty4bqhca",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/0b4bfeb9808c9446c6602b9f1ff91066a2d252f9ce62ff3dd78b5423a7a63a05.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67f8b3b4379abe24cf2b56281abd6584f2b796da329ce76895a1df4c97613b97.jpeg",
    "https://cdn.faire.com/fastly/45f64f13be3cdf72713a9befd7089d2984f770a8c28ae68294632cbe081064c7.jpeg",
    "https://cdn.faire.com/fastly/14ea027884b05d002f8cf91a5f45db49c3209a03865f9ca13bb2b18d9aa8727a.jpeg",
    "https://cdn.faire.com/fastly/749e86ccec757a4dee8388113b1779b8bc5579f6da6026fd62293dc65c275e65.jpeg",
    "https://cdn.faire.com/fastly/956e6ca745d9ba5b157a662cc38d9ea0e2b00c0c5d1cab7c90afc6cd79e24946.jpeg",
    "https://cdn.faire.com/fastly/9a2585e4225d1cc4fb58cf393320a1d22212eac5a0dcab6eab6ec67cf5680d93.jpeg",
    "https://cdn.faire.com/fastly/c7c39bb9da5cbeee60523f601915246a8f87dcc83897648425b438b07b4e0e0e.jpeg",
    "https://cdn.faire.com/fastly/2b443c8903a25548935f3e30e86e2bfb1a110114350f46d2d33b110d192b178d.jpeg",
    "https://cdn.faire.com/fastly/eb4cb3a4f4ae505ba8227ef9e6ad8e5038a2a890f11170799ed8371664a1b107.jpeg",
    "https://cdn.faire.com/fastly/28868daaa7370061ebf7bd94c501671c0bbf5a68c8b4c81e2cec62fa98b075b9.jpeg",
  ],
  priceDollars: 17,
  description:
    'Cute little puka shells dangle from dainty 14k gold filled or sterling silver chains.\n\n• Longest drop is 2"\n• 14k gold filled 1.1mm cable chain\n• Sterling silver 1.4mm cable chain\n• Available in 15", 16" and 18" length',
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:38.388Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
